import { API_URLS } from 'src/constants/apis';
import { APIEventType } from 'src/types';
import { httpClient } from 'src/utils/httpClient/httpClient';

export const saveEvent = async (
  data: APIEventType,
  jwt: string,
): Promise<Response> => {
  const res = await httpClient(
    API_URLS.saveEvent,
    'POST',
    {
      Authorization: `Bearer ${jwt}`,
    },
    data,
  );

  return res;
};
